import styleInject from '../../node_modules/style-inject/dist/153f6fceb51bb0547b1c47281772019ca2a83d6f1f66a0d8c0fb968a56fe84d7.cfe-internal.js';

var css_248z = "._xodgZ{font-size:14px}._2PlOn{color:#6a6d70;line-height:20px;display:inline-flex;flex-direction:column;align-items:flex-start}._3M0jp{color:#0b6ed0}";
var styles = {"label":"_xodgZ","control":"_2PlOn","focused":"_3M0jp"};
styleInject(css_248z);

export { styles as default };
